import React, { useState } from 'react';
import {
  Grid, Typography, Button, Box, Container, Divider
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebook, faTwitter, faInstagram, faLinkedin, faWhatsapp
} from '@fortawesome/free-brands-svg-icons';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/qural1.png';
import footer from "../assets/logo-Q.png";
import verify from "../asserts/verified.webp";
import { makeApiRequest } from '../utils/api';
import bg from '../asserts/Background.png';



const VerificationPage = () => {
  const location = useLocation();
  const { data: certificateData, buttonBackgroundColor } = location.state || {};
  const [showSeal,setShowSeal] = useState(certificateData.verify_status);

  if (!certificateData) return <Typography>No certificate data found</Typography>;
  const onVerifyClick = async () => {
    try {
      const response = await makeApiRequest('post', '/api/certificate/verify', {
        token: localStorage.getItem('authToken'),
        id: certificateData.id
      });
      if(response.status == 'success'){
        setShowSeal(1);
      }
      if (response.status != "success") {
        alert("Error in verification");
      }
    }
    catch (err) {
      console.error("Error fetching data:", err);
    }
  }

  return (
    <Box>
      <Grid container alignItems="center" className="header_first" sx={{ m: 0 }}>
        <Grid item xs={4}>
          <img src={logo} alt="Header Logo" style={{ maxWidth: '100%' }} />
        </Grid>
        <Grid item xs={6}>
          <Typography variant="h4" component="h1">
            Student's <span style={{ fontWeight: 'bold' }}>Certificate</span>
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Button
            onClick={onVerifyClick}
            variant="contained"
            sx={{ backgroundColor: showSeal === 1 ? '#43a047' : '#155ccb', borderRadius: '10px' }}
          >
            <Typography variant="h6" color="white">{showSeal == 1 ? 'Verified' : 'Verify'}</Typography>
          </Button>
        </Grid>
      </Grid>

      <Container sx={{ mt: 4, backgroundImage: `url(${bg})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4} sx={{ paddingBottom: '20px' }}>
            <img
              src={`${process.env.REACT_APP_API_URL}/documents/${certificateData.profile}`}
              // src={`http://127.0.0.1:8000/documents/${certificateData.profile}`}
              alt="Profile"
              style={{ width: '100%' }} />
          </Grid>
          <Grid item xs={12} md={8} sx={{ color: '#ffffff' }}>
            <Box>
              {[
                { label: 'Student Name', value: certificateData.student_name },
                { label: 'Certificate ID', value: certificateData.user_id },
                { label: 'Course Name', value: certificateData.course },
                { label: 'Course Duration', value: `${certificateData.start_date} - ${certificateData.end_date}` },
                { label: 'Date of Issue', value: certificateData.date }
              ].map((item, index) => (
                <Box key={index} sx={{ mb: 2 }}>
                  <Typography variant="subtitle2">{item.label}</Typography>
                  <Typography variant="h6">{item.value}</Typography>
                  <Divider />
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Container>

      <Grid container spacing={2} justifyContent="center" sx={{ mt: 4 }}>
        {[
          certificateData.first_page_path,
          ...(String(certificateData.mode).toLowerCase() === 'online' ? [] : [certificateData.second_page_path])
        ].filter(Boolean).map((imgSrc, idx) => (
          <Grid item xs={11} md={5} key={idx} sx={{ position: 'relative' }}>
            <img src={`${process.env.REACT_APP_API_URL}/${imgSrc}` || ''} alt={`Certificate Page ${idx + 1}`} style={{ width: '100%' }} />
            {showSeal == 1 && (
              <img
                src={verify}
                alt="Seal"
                className="seal"
                style={{
                  position: 'absolute',
                  bottom: '10px',
                  right: '10px',
                  width: '60px'
                }}
              />
            )}
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 6, backgroundColor: '#30449A', py: 4, color: '#f5f5f5' }}>
        <Container>
          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <Typography variant="h6">ABOUT</Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                Welcome to Qural Engineering Tomorrow Together (QETT)! We're here to help you become a great engineer. Our programs give you both knowledge and practical skills. Join QETT and get ready to shine in the engineering world!
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                <FontAwesomeIcon icon={faFacebook} />
                <FontAwesomeIcon icon={faTwitter} />
                <FontAwesomeIcon icon={faInstagram} />
                <FontAwesomeIcon icon={faLinkedin} />
                <FontAwesomeIcon icon={faWhatsapp} />
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Typography variant="h6">CONTACT - TRICHY</Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                S.No.330/6A, Chennai Main Road, Near Aariyas Hotel, Konalai, Tiruchirappalli, Tamil Nadu 621105
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                <FontAwesomeIcon icon={faPhone} />
                <Typography sx={{ ml: 1 }}>+91 8754111860</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                <FontAwesomeIcon icon={faEnvelope} />
                <Typography sx={{ ml: 1 }}>trichy@quraltalent.com</Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Typography variant="h6">CONTACT - CHENNAI</Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                No 15 and 16, 1st Link Road, Nehru Nagar, Kottivakkam OMR, Chennai, Tamil Nadu 600096
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                <FontAwesomeIcon icon={faPhone} />
                <Typography sx={{ ml: 1 }}>+91 8925075558</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                <FontAwesomeIcon icon={faEnvelope} />
                <Typography sx={{ ml: 1 }}>chennai@quraltalent.com</Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Grid container alignItems="center" className="footer_end" sx={{ m: 0, py: 2 }}>
        <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'flex-end', padding: '5px' }}>
          <img src={footer} alt="Footer Logo" style={{ width: '30px' }} />
        </Grid>
        <Grid item xs={11}>
          <Typography variant="body2">Copyright @ Qural Talent. All Rights Reserved ©</Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default VerificationPage;
